import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Notification API calls
 */
const notificationService = {
  /**
   * Get all notifications with pagination and filters
   */
  getNotifications: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        read = '',
        type = '',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        read: read !== '' ? read : undefined,
        type,
      });

      return await apiClient.get(`${API_ENDPOINTS.NOTIFICATIONS.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'notificationService.getNotifications'));
    }
  },

  /**
   * Get unread notifications count
   */
  getUnreadCount: async () => {
    try {
      return await apiClient.get(API_ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT);
    } catch (error) {
      throw new Error(handleError(error, 'notificationService.getUnreadCount'));
    }
  },

  /**
   * Mark notification as read
   */
  markAsRead: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.NOTIFICATIONS.MARK_AS_READ(id));
    } catch (error) {
      throw new Error(handleError(error, 'notificationService.markAsRead'));
    }
  },

  /**
   * Mark all notifications as read
   */
  markAllAsRead: async () => {
    try {
      return await apiClient.patch(API_ENDPOINTS.NOTIFICATIONS.MARK_ALL_AS_READ);
    } catch (error) {
      throw new Error(handleError(error, 'notificationService.markAllAsRead'));
    }
  },

  /**
   * Delete notification
   */
  deleteNotification: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.NOTIFICATIONS.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'notificationService.deleteNotification'));
    }
  },
};

export default notificationService;
